export { default } from "@/features/profile/screens/settings";
